import { api } from "apiServer"
import config from "lib/config"
import { Layout } from "components/common"
import Image from "next/legacy/image"
import SwiperTopic from "components/SwiperTopic"
import { useEffect, useState } from "react"
import { trackGA } from "lib/func"
import { getPropsCategoryPage } from "lib/dataStore"
import { getCookieValue } from "lib/func"

function Component({ lists, id }) {
  const [_lists, setLists] = useState(lists)
  const [_id, setId] = useState(id)
  const [lastFetchTime, setLastFetchTime] = useState(Date.now())

  useEffect(() => {
    if (_id === "esports") {
      trackGA("Esports", "ESPORTS_TAB")
    } else {
      trackGA(name, "CATEGORY")
    }
  }, [_id])

  const fetchData = async () => {
    try {
      console.log("Fetching data")
      const timestamp = Date.now()
      const accessToken = getCookieValue("accessToken")

      if (id === "esports") {
        const { success, data } = await api.getDetailCategory(accessToken, id, { menu_code: "ESPORTS" })
        if (success) {
          setLists(data)
          setId(id)
        }
      } else {
        const { success, data } = await api.getDetailCategory(accessToken, id, {})
        if (success) {
          setLists(data)
          setId(id)
        }
      }
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
      setLastFetchTime(timestamp)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = Date.now()
        const lastFetchTime = sessionStorage.getItem("lastFetchTime") || 0
        const timeElapsed = currentTime - lastFetchTime
        if (timeElapsed >= config.TIME_REQUEST_HOME_PAGE) {
          fetchData()
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [lastFetchTime])

  return (
    <section className="mb-12">
      <div className="relative z-0 mb-10">
        <div className="relative">
          <div className="absolute -right-4 top-1/2 z-20 transform -translate-y-1/2"></div>
          <div className="overflow-x-hidden max-w-screen-xl xl:m-auto">
            <div className="flex wapper__slide rounder-lg">
              <MyImage
                name=" image"
                thumbnail={_lists.thumbnail || "https://stvinaprod.vtvcab.vn/94f98a7a-6ded-4e15-ac0e-27c26829307c.png"}
              />
            </div>
          </div>
          <div className="pt-0 mt-2 lg:mt-16 overflow-x-hidden md:mt-0 max-w-screen-xl xl:m-auto px-4">
            {_lists.categories?.length > 0 &&
              _lists.categories?.map((item) => {
                const { id, contents } = item
                return <div key={id}>{contents?.length > 0 && <SwiperTopic {...item} type_block={1} />}</div>
              })}
            {!_lists.categories?.length > 0 && (
              <div className="h-48 text-dark-100 flex items-center justify-center">Nội dung đang được cập nhật</div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
export default Component
Component.Layout = Layout

function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  return `${base_url}${size}/${thumbnail}`
}

function MyImage({ base_url, thumbnail, name }) {
  return (
    <div className="relative">
      <div className="absolute z-20 shadow bottom-0 left-0 bg-dark-50 flex h-44 items-center  w-full bg-slide-bander"></div>

      <div className="fix_img">
        <Image
          blurDataURL={renderUrl(base_url, thumbnail, "160x90")}
          placeholder="blur"
          className="z-0 "
          src={renderUrl(base_url, thumbnail, "720x405")}
          height={1475}
          width={4000}
          alt={name}
        />
      </div>
    </div>
  )
}

export async function getServerSideProps({ req, query, res }) {
  let pageProps = {
    lists: [],
    id: ""
  }

  try {
    pageProps = await getPropsCategoryPage(req, query, res)
  } catch (error) {
    console.log(error)
  }
  return { props: pageProps }
}
